import React from "react"

import { withStyles } from "@material-ui/core"
import contribuinteStyle from "../../../assets/css/layout/contribuinteStyle"
import MenuDashboard from "../../MenuDashboard"

import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider"
import theme from "../../../assets/css/theme"
import { movimentosAlvaraTabChanged } from "../../../actions"
import Autorenew from "@material-ui/icons/Autorenew"
import Update from "@material-ui/icons/Update"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import GeracaoDam from "./GeracaoDam"
import AlterarVencimentoDam from "./AlterarVencimentoDam"

const tab = [
  {
    name: "Geração de DAM",
    icon: <Autorenew />
  },
  {
    name: "Alterar Vencimento DAM",
    icon: <Update />
  }
]

class MovimentoAlvara extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: "",
      error: "",
      field: 0
    }
    this.handleFieldChange = this.handleFieldChange.bind(this)
  }

  handleFieldChange(value) {
    this.props.movimentosAlvaraTabChanged(value)
  }
  render() {
    const { classes, field } = this.props
    return (
      <div className={classes.container}>
        <MuiThemeProvider theme={theme}>
          <MenuDashboard
            names={tab}
            onChange={this.handleFieldChange}
            value={field}
          />
          {field === 0 && <GeracaoDam />}
          {field === 1 && <AlterarVencimentoDam />}
        </MuiThemeProvider>
      </div>
    )
  }
}
function mapStateToProps(state) {
  return {
    field: state.tabLayout.movimentosAlvaraTabSelected
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ movimentosAlvaraTabChanged }, dispatch)
}
MovimentoAlvara = connect(
  mapStateToProps,
  mapDispatchToProps
)(MovimentoAlvara)
export default withStyles(contribuinteStyle)(MovimentoAlvara)
